<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>


<style>
/* ===== 白色清爽后台设计系统 ===== */
:root {
  --primary-color: #2f6bff;
  --primary-light: #5b8cff;
  --primary-gradient: linear-gradient(135deg, #2f6bff 0%, #4f8cff 100%);
  --accent-green: #18a058;
  --accent-red: #f56c6c;
  --accent-yellow: #e6a23c;
  --bg-primary: #f5f7fb;
  --bg-card: #ffffff;
  --bg-sidebar: #ffffff;
  --text-primary: #1f2937;
  --text-secondary: #6b7280;
  --text-muted: #9ca3af;
  --border-color: #e5eaf3;
  --border-strong: #c9d6ee;
  --shadow-sm: 0 1px 3px rgba(31, 41, 55, 0.06);
  --shadow-md: 0 8px 24px rgba(31, 41, 55, 0.08);
  --shadow-lg: 0 16px 42px rgba(31, 41, 55, 0.12);
  --radius-md: 12px;
  --radius-lg: 16px;
}
* { margin: 0; padding: 0; box-sizing: border-box; }
html, body { background: var(--bg-primary) !important; }
body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--text-primary) !important;
  line-height: 1.6;
  background: var(--bg-primary) !important;
}
#app { height: 100vh; }
::-webkit-scrollbar { width: 8px; height: 8px; }
::-webkit-scrollbar-thumb { background: #cdd7ea; border-radius: 999px; }
::-webkit-scrollbar-track { background: transparent; }

/* 布局框架 */
.el-container { height: 100%; }
.el-aside { background: var(--bg-sidebar) !important; border-right: 1px solid var(--border-color) !important; box-shadow: 4px 0 18px rgba(31,41,55,.04); }
.el-menu { border-right: none; background: transparent !important; }
.el-header {
  background: rgba(255,255,255,.92) !important;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border-color) !important;
  box-shadow: var(--shadow-sm);
  color: var(--text-primary) !important;
}
.el-main { padding: 22px; background: var(--bg-primary) !important; }

/* 卡片/容器 */
.el-card, .table-card, .search-area, .filter-bar, .statistics-cards .stat-card, .table-container, .detail-content, .permission-config {
  background: var(--bg-card) !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: var(--shadow-sm) !important;
  color: var(--text-primary) !important;
}
.el-card { border-radius: var(--radius-lg) !important; transition: box-shadow .2s ease, border-color .2s ease; }
.el-card:hover, .table-card:hover { border-color: var(--border-strong) !important; box-shadow: var(--shadow-md) !important; }
.el-card__header { padding: 18px 22px !important; border-bottom: 1px solid var(--border-color) !important; font-weight: 700; color: var(--text-primary) !important; background: #fff !important; }
.el-card__body { padding: 22px !important; color: var(--text-primary) !important; }
.page-title, .layout-container h1, .layout-container h2, .layout-container h3, .layout-container h4 { color: var(--text-primary) !important; }
.page-title::after { content: ''; display: block; width: 52px; height: 3px; margin-top: 8px; background: var(--primary-gradient); border-radius: 999px; }
/* 仅作用于后台布局内：H5 聊天页是独立路由，不能影响其气泡文字颜色 */
.layout-container p, .layout-container span, .layout-container label, .el-form-item__label, .input-label, .document-label { color: var(--text-secondary) !important; }
.el-main > * { background: transparent !important; }

/* 统计卡片 */
.statistics-cards .stat-card, .stat-card, .overview-card, .data-card { border-radius: 16px !important; background: #fff !important; }
.stat-number { color: var(--text-primary) !important; font-weight: 800; }
.stat-label { color: var(--text-secondary) !important; }

/* 按钮 */
.el-button { border-radius: 10px !important; font-weight: 600 !important; border: 1px solid var(--border-strong) !important; background: #fff !important; color: var(--text-primary) !important; transition: all .18s ease !important; }
.el-button:hover { border-color: var(--primary-color) !important; color: var(--primary-color) !important; box-shadow: 0 6px 16px rgba(47,107,255,.12); }
.el-button--primary { background: var(--primary-gradient) !important; border: none !important; color: #fff !important; box-shadow: 0 8px 18px rgba(47,107,255,.22) !important; }
.el-button--success { background: #18a058 !important; border: none !important; color: #fff !important; }
.el-button--danger { background: #f56c6c !important; border: none !important; color: #fff !important; }
.el-button--warning { background: #e6a23c !important; border: none !important; color: #fff !important; }
.el-button--text { background: transparent !important; border: none !important; color: var(--primary-color) !important; }

/* 表单 */
.el-input__inner, .el-textarea__inner, .el-select .el-input__inner {
  border-radius: 10px !important; border: 1px solid #d9e2f2 !important; background: #fff !important; color: var(--text-primary) !important;
}
.el-input__inner::placeholder, .el-textarea__inner::placeholder { color: #a4b0c3 !important; }
.el-input__inner:focus, .el-textarea__inner:focus { border-color: var(--primary-color) !important; box-shadow: 0 0 0 3px rgba(47,107,255,.12) !important; }
.el-select-dropdown, .el-picker-panel, .el-message-box, .el-popper { background: #fff !important; border: 1px solid var(--border-color) !important; color: var(--text-primary) !important; box-shadow: var(--shadow-lg) !important; }
.el-select-dropdown__item { color: var(--text-primary) !important; }
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover { background: #f0f5ff !important; }
.el-select-dropdown__item.selected { color: var(--primary-color) !important; }

/* 表格 */
.el-table { border-radius: 14px; overflow: hidden; background: #fff !important; color: var(--text-primary) !important; }
.el-table::before, .el-table::after { background-color: var(--border-color) !important; }
.el-table th { background: #f7f9fd !important; color: #374151 !important; font-weight: 700 !important; border-bottom: 1px solid var(--border-color) !important; }
.el-table td { background: #fff !important; color: #4b5563 !important; border-bottom: 1px solid #eef2f8 !important; }
.el-table--striped .el-table__body tr.el-table__row--striped td { background: #fbfcff !important; }
.el-table__body tr:hover > td { background: #f0f5ff !important; }
.el-table--border, .el-table--border td, .el-table--border th { border-color: #edf1f7 !important; }

/* 标签/分页/弹窗 */
.el-tag { border-radius: 999px !important; font-weight: 600 !important; }
.el-pagination { margin-top: 22px; color: var(--text-secondary) !important; }
.el-pagination .el-pager li { border-radius: 8px !important; background: #fff !important; color: var(--text-primary) !important; border: 1px solid var(--border-color) !important; }
.el-pagination .el-pager li.active { background: var(--primary-color) !important; color: #fff !important; border-color: var(--primary-color) !important; }
.el-dialog { border-radius: 16px !important; background: #fff !important; border: 1px solid var(--border-color) !important; box-shadow: var(--shadow-lg) !important; }
.el-dialog__header { padding: 18px 22px !important; border-bottom: 1px solid var(--border-color) !important; background: #fff !important; }
.el-dialog__title { color: var(--text-primary) !important; font-weight: 700 !important; }
.el-dialog__body { color: var(--text-primary) !important; }
.el-message { background: #fff !important; border-color: var(--border-color) !important; color: var(--text-primary) !important; }
.el-loading-mask { background-color: rgba(255,255,255,.72) !important; }
.el-tree { background: transparent !important; color: var(--text-primary) !important; }
.el-tree-node__content:hover { background: #f0f5ff !important; }


/* Layout 白色压盖 */
body .main-container { background: var(--bg-primary) !important; }
body .main-content { background: var(--bg-primary) !important; }
body .header { background: rgba(255,255,255,.94) !important; border-bottom: 1px solid var(--border-color) !important; box-shadow: var(--shadow-sm) !important; }
body .header::after { background: linear-gradient(90deg, var(--primary-color), rgba(47,107,255,.18), transparent 70%) !important; height: 2px !important; }
body .header-page-title { color: var(--text-primary) !important; border-left-color: var(--primary-color) !important; }
body .collapse-btn { color: #6b7280 !important; }
body .collapse-btn:hover { background: #f0f5ff !important; color: var(--primary-color) !important; }
body .user-info { border-color: var(--border-color) !important; background: #fff !important; }
body .user-info:hover { border-color: var(--border-strong) !important; box-shadow: var(--shadow-md) !important; }
body .user-avatar { background: var(--primary-gradient) !important; }
body .sidebar { background: #fff !important; }
body .logo-icon { background: var(--primary-gradient) !important; box-shadow: 0 8px 22px rgba(47,107,255,.22) !important; }
body .sidebar-menu .el-menu-item, body .sidebar-menu .el-submenu__title { color: #4b5563 !important; }
body .sidebar-menu .el-menu-item i, body .sidebar-menu .el-submenu__title i { color: #9aa6bd !important; }
body .sidebar-menu .el-menu-item:hover, body .sidebar-menu .el-submenu__title:hover { background: #f0f5ff !important; color: var(--primary-color) !important; }
body .sidebar-menu .el-menu-item:hover i, body .sidebar-menu .el-submenu__title:hover i { color: var(--primary-color) !important; }
body .sidebar-menu.el-menu .el-menu-item.is-active,
body .sidebar-menu.el-menu .el-submenu .el-menu-item.is-active {
  background: #edf4ff !important;
  color: var(--primary-color) !important;
  box-shadow: inset 3px 0 0 var(--primary-color) !important;
}
body .sidebar-menu.el-menu .el-menu-item.is-active i { color: var(--primary-color) !important; }
body .footer-dot { background: var(--primary-color) !important; }

/* 小细节 */
.el-divider { background-color: var(--border-color) !important; }
.el-divider__text { background: transparent !important; color: var(--text-secondary) !important; }
a, .file-link { color: var(--primary-color) !important; }
.fade-in { animation: fadeIn .3s ease; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: none; } }

/* 侧边栏也改为白色（压盖 Layout scoped 深色） */
body .layout-container .sidebar { background: #ffffff !important; border-right: 1px solid var(--border-color) !important; }
body .layout-container .logo-text { color: var(--text-primary) !important; }
body .layout-container .logo-sub { color: var(--text-muted) !important; }
body .layout-container .sidebar-footer { border-top: 1px solid var(--border-color) !important; color: var(--text-muted) !important; }
body .layout-container .sidebar-menu .el-menu-item,
body .layout-container .sidebar-menu .el-submenu__title { color: #4b5563 !important; }
body .layout-container .sidebar-menu .el-menu-item i,
body .layout-container .sidebar-menu .el-submenu__title i { color: #9aa6bd !important; }
body .layout-container .sidebar-menu .el-submenu .el-menu { background: #fbfcff !important; }

/* 同级双类选择器压盖 scoped data-v 深色侧边栏 */
body .layout-container .sidebar.sidebar { background: #ffffff !important; border-right: 1px solid var(--border-color) !important; }
body .layout-container .sidebar.sidebar .logo-text { color: var(--text-primary) !important; }
body .layout-container .sidebar.sidebar .logo-sub { color: var(--text-muted) !important; }
body .layout-container .sidebar.sidebar .sidebar-footer { border-top: 1px solid var(--border-color) !important; color: var(--text-muted) !important; }
</style>

